import React, { memo, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs, Row, Col } from 'antd'

import classes from './styles.module.scss'
import { TProfileProps } from 'models'
import { StoreValue } from 'store'
import {
	RegisterForm,
	HeaderForm,
	ResendQRCode,
	SuccessfullyOperation,
	ClosedOperation,
} from './components'

const { TabPane } = Tabs

const StudentKit: React.FunctionComponent<TProfileProps> = () => {
	const { i18n } = useTranslation()
	const t = i18n.getFixedT('ro')
	// const [isClosed, setIsClosed] = useState(false)

	const [showSuccessfullyOperationPage, setShowSuccessfullyOperationPage] =
		useState(false)
	const [successfullyOperationText, setSuccessfullyOperationText] =
		useState('')

	const handleRegistration = useCallback(() => {
		setShowSuccessfullyOperationPage(true)
		setSuccessfullyOperationText(t(`successfullyRegisteredForStudentsKit`))
	}, [t])

	const handleResendQRCode = useCallback(() => {
		setSuccessfullyOperationText(
			t('You will receive the email with the QR code for StudentsKit'),
		)
		setShowSuccessfullyOperationPage(true)
	}, [t])

	return (
		<>
			{
				// isClosed
				false ? (
					<ClosedOperation />
				) : !showSuccessfullyOperationPage ? (
					<Row className={classes.container}>
						<Col xs={22} md={16}>
							<HeaderForm />
							<Tabs
								className={classes.tabName}
								defaultActiveKey="register"
							>
								<TabPane tab={t('Register')} key="register">
									<RegisterForm
										handleRegistration={handleRegistration}
									/>
								</TabPane>
								<TabPane
									tab={t('Recover code')}
									key="recoverCode"
								>
									<ResendQRCode
										handleResendQRCode={handleResendQRCode}
									/>
								</TabPane>
							</Tabs>
						</Col>
					</Row>
				) : (
					<SuccessfullyOperation text={successfullyOperationText} />
				)
			}
		</>
	)
}

export default memo((props: TProfileProps) => (
	<StoreValue keys={['user|storeUser']}>
		<StudentKit {...props} />
	</StoreValue>
))
